import { render, staticRenderFns } from "./border-radius-settings.vue?vue&type=template&id=9f7952aa&scoped=true&"
import script from "./border-radius-settings.vue?vue&type=script&lang=js&"
export * from "./border-radius-settings.vue?vue&type=script&lang=js&"
import style0 from "./border-radius-settings.vue?vue&type=style&index=0&id=9f7952aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7952aa",
  null
  
)

export default component.exports